import { Component } from "react";
import Link from "admin/shared/ui/Link.Component";

// markup
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

// custom markup
import RetractableSidebar from "../../home/components/Retractable.Sidebar";

// icons
import SystemBrowserIcon from "@material-ui/icons/Computer";
import AutoInvestIcon from "@material-ui/icons/Memory";

class SoldLoansMenuComponent extends Component {
  render() {
    let wrapperStyle = {
      display: "flex",
      minHeight: "100%",
    };

    let activeStyle = {
      borderLeft: "#ff9300 4px solid",
      display: "block",
      background: "#bdb76b",
    };

    return (
      <div style={wrapperStyle}>
        <RetractableSidebar storageKey="soldMenu">
          <List>
            <Link
              activeClassName={"selected"}
              activeStyle={activeStyle}
              toState={"sold"}
            >
              <ListItem button>
                <ListItemIcon>
                  <AutoInvestIcon />
                </ListItemIcon>
                <ListItemText primary="Sold" />
              </ListItem>
            </Link>
            <Link
              activeClassName={"selected"}
              activeStyle={activeStyle}
              toState={"dca"}
            >
              <ListItem button>
                <ListItemIcon>
                  <SystemBrowserIcon />
                </ListItemIcon>
                <ListItemText primary="DCA" />
              </ListItem>
            </Link>
          </List>
        </RetractableSidebar>
        <div
          style={{
            //padding: '20px',
            width: "100%",
            boxSizing: "border-box",
            overflow: "auto",
            backgroundColor: "#f9f9f9",
          }}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}
export default SoldLoansMenuComponent;
